const fieldStyle = {
  mb: 1,
};

export { fieldStyle };
